import { Badge, Button, ErrorMessage, Spinner } from "../../../../../widgets";

import { FC } from "react";
import { FetchStatus } from "../../../../../base/types";
import { IControlAttributes } from "../../../../../base/models";
import clsx from "clsx";
import { useSubmitButtonProperties } from "./SubmitButtonProperties";

export const DraftSubmitButtonComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, error, properties, draftText } = useSubmitButtonProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return (
        <div className={"d-flex position-relative"}>
            <Badge
                className={"position-absolute top-0 end-0 text-nowrap fs-9 rounded-0"}
                badgeStyle="primary">
                Submit Button
            </Badge>
            <Button
                {...properties}
                className={clsx(className, "flex-fill")}
                iconClassName="me-1"
                label={draftText}
                disabled={true}
            >
                {children}
            </Button>
        </div>)
}